// Gujarati language translations for WCD portal
export const translations = {
  en: {
    common: {
      home: "Home",
      dashboard: "Dashboard", 
      signIn: "Sign In",
      signOut: "Sign Out",
      loading: "Loading...",
      submit: "Submit",
      cancel: "Cancel",
      email: "Email",
      password: "Password",
      name: "Name"
    },
    header: {
      title: "Gujarat Women & Child Development Department",
      subtitle: "Empowering Women & Ensuring Child Development Through AI-Driven Governance",
      wcdInitiatives: "WCD Initiatives",
      gujaratMap: "Gujarat Map",
      schemesNews: "Schemes & News",
      partnerships: "Partnerships"
    },
    hero: {
      title: "Gujarat Women & Child Development Department",
      subtitle: "Empowering Women & Ensuring Child Development Through AI-Driven Governance",
      description: "Leading comprehensive development programs for women empowerment and child nutrition in Gujarat through innovative technology and data-driven decision making.",
      exploreButton: "Explore WCD Dashboard"
    },
    schemes: {
      vahliDikri: "Vahli Dikri Yojana",
      gangaSwarupa: "Ganga Swarupa Pension Scheme",
      icds: "Integrated Child Development Services",
      matrushakti: "Mukhyamantri Matrushakti Yojana",
      dudhSanjeevani: "Dudh Sanjeevani Yojana"
    },
    dashboard: {
      childDevelopment: "Child Development Metrics",
      womenEmpowerment: "Women Empowerment Indicators",
      nutritionCoverage: "Child Nutrition Coverage",
      anganwadiDigitization: "Anganwadi Digitization",
      immunizationRate: "Immunization Rate",
      preSchoolEnrollment: "Pre-School Enrollment"
    }
  },
  gu: {
    common: {
      home: "ઘર",
      dashboard: "ડેશબોર્ડ",
      signIn: "સાઇન ઇન",
      signOut: "સાઇન આઉટ",
      loading: "લોડ થઈ રહ્યું છે...",
      submit: "સબમિટ કરો",
      cancel: "રદ કરો",
      email: "ઇમેઇલ",
      password: "પાસવર્ડ",
      name: "નામ"
    },
    header: {
      title: "ગુજરાત મહિલા અને બાળ વિકાસ વિભાગ",
      subtitle: "AI-આધારિત ગવર્નન્સ દ્વારા મહિલા સશક્તિકરણ અને બાળ વિકાસ સુનિશ્ચિત કરવું",
      wcdInitiatives: "WCD પહેલ",
      gujaratMap: "ગુજરાત નકશો",
      schemesNews: "યોજનાઓ અને સમાચાર",
      partnerships: "ભાગીદારી"
    },
    hero: {
      title: "ગુજરાત મહિલા અને બાળ વિકાસ વિભાગ",
      subtitle: "AI-આધારિત ગવર્નન્સ દ્વારા મહિલા સશક્તિકરણ અને બાળ વિકાસ સુનિશ્ચિત કરવું",
      description: "ગુજરાતમાં નવીન તકનીક અને ડેટા-આધારિત નિર્ણય લેવાની પ્રક્રિયા દ્વારા મહિલા સશક્તિકરણ અને બાળ પોષણ માટે વ્યાપક વિકાસ કાર્યક્રમોની આગેવાની કરવી.",
      exploreButton: "WCD ડેશબોર્ડ અન્વેષણ કરો"
    },
    schemes: {
      vahliDikri: "વહાલી દીકરી યોજના",
      gangaSwarupa: "ગંગા સ્વરૂપ પેન્શન યોજના", 
      icds: "એકીકૃત બાળ વિકાસ સેવાઓ (ICDS)",
      matrushakti: "મુખ્યમંત્રી માતૃશક્તિ યોજના",
      dudhSanjeevani: "દૂધ સંજીવની યોજના"
    },
    dashboard: {
      childDevelopment: "બાળ વિકાસ મેટ્રિક્સ",
      womenEmpowerment: "મહિલા સશક્તિકરણ સૂચકાંકો",
      nutritionCoverage: "બાળ પોષણ કવરેજ",
      anganwadiDigitization: "આંગણવાડી ડિજિટાઈઝેશન",
      immunizationRate: "રસીકરણ દર",
      preSchoolEnrollment: "પૂર્વ-શાળા નોંધણી"
    }
  }
};

// Language utility functions
export const getCurrentLanguage = () => {
  return localStorage.getItem('language') || 'en';
};

export const setLanguage = (lang) => {
  localStorage.setItem('language', lang);
  // Trigger re-render by dispatching custom event
  window.dispatchEvent(new CustomEvent('languageChange', { detail: lang }));
};

export const t = (key, lang = null) => {
  const currentLang = lang || getCurrentLanguage();
  const keys = key.split('.');
  let value = translations[currentLang];
  
  for (const k of keys) {
    value = value?.[k];
  }
  
  // Fallback to English if translation not found
  if (!value && currentLang !== 'en') {
    value = translations.en;
    for (const k of keys) {
      value = value?.[k];
    }
  }
  
  return value || key;
};